export default __webpack_public_path__ + "static/media/Making-Entrance.45e79132.jpg";